import { render } from "./MultipleTestBarcodes.vue?vue&type=template&id=b80aa54a"
import script from "./MultipleTestBarcodes.vue?vue&type=script&lang=js"
export * from "./MultipleTestBarcodes.vue?vue&type=script&lang=js"

import "./MultipleTestBarcodes.vue?vue&type=style&index=0&id=b80aa54a&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/MultipleTestBarcodes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b80aa54a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b80aa54a', __exports__)) {
    console.log('reload')
    api.reload('b80aa54a', __exports__)
  }
  
  module.hot.accept("./MultipleTestBarcodes.vue?vue&type=template&id=b80aa54a", () => {
    console.log('re-render')
    api.rerender('b80aa54a', render)
  })

}


export default __exports__